import { Box, styled } from '@mui/material';

export const AmountWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  backgroundColor: theme.palette.background.main,
}));

export const AmountContentRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
}));

export const AmountButtonRow = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 1),
}));
